<template>
  <div class="pinkdetail">
    <img class="bg" src="@assets/images/detail_bg1.png" />
    <div class="teamnum acea-row">
      <img class="" src="@assets/images/people_icon.png" />
      <span class="a">{{ pinkinfo.ptnum }}人团</span>
    </div>
    <div class="title acea-row">
      <span class="a line1">{{ storeInfo.store_name }}</span>
      正在疯抢中
    </div>
    <div class="pinkinfo">
      <div class="goodsinfo acea-row row-between-wrapper">
        <img class="goods_img" :src="storeInfo.image" />
        <div class="info acea-row row-between-wrapper">
          <div class="store_name line2">
            {{ storeInfo.store_name }}
          </div>
          <div class="progress acea-row">
            <div class="progress_1">
              <div
                class="sel"
                :style="{ width: (pinkinfo.num / pinkinfo.ptnum) * 100 + '%' }"
              ></div>
            </div>
            <div class="num">{{ pinkinfo.num }}/{{ pinkinfo.ptnum }}</div>
          </div>
          <div class="butie">
            预计获得红包￥<span class="a">{{ pinkinfo.ctj }}</span>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="pinkinfos">
        <div class="acea-row qi">
          <span class="a"></span>
          <span class="b">第{{ pinkinfo.periods }}期</span>
          <span class="c"></span>
        </div>
        <div class="status acea-row">
          <img class="" src="@assets/images/success_icon.png" />
          <span class="a">参团成功</span>
        </div>
        <div class="num">
          还差<span class="a">{{ pinkinfo.ptnum - pinkinfo.num }}</span>
          份成团，请留意成团开奖通知！
        </div>
        <div class="userlist acea-row">
          <div v-for="(item, index) in pinkinfo.user" :key="index">
            <img class="" v-if="index < 7" :src="item.avatar" />
          </div>
          <!-- <img
            class=""
            v-for="item in pinkinfo.ptnum > 6 ? 7 - pinkinfo.user.length : pinkinfo.ptnum - pinkinfo.user.length"
            :src="'@assets/images/vacancy.png?time=' + item"
          /> -->
          <img
            v-if="pinkinfo.user.length > 7"
            class="more"
            src="@assets/images/more_btn.png"
          />
        </div>
      </div>
      <button @click="listenerActionSheet" class="invite_btn">
        邀请好友参团
      </button>
      <router-link class="gohome" to="/">
        返回首页
      </router-link>
    </div>
    <div class="rule_title acea-row">
      <img class="" src="@assets/images/rule_left.png" />
      <span class="a">拼团规则</span>
      <img class="" src="@assets/images/rule_right.png" />
    </div>
    <img class="rule_img" src="@assets/images/detail_1.png" />
    <div
      class="mask acea-row row-middle row-center"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    >
      <div class="generate-posters" :class="posters ? 'on' : ''">
        <div class="poster_title">
          还差<span class="a">{{ pinkinfo.ptnum - pinkinfo.num }}</span
          >人，赶快邀请好友来拼单吧
        </div>
        <div class="poster_tipe">拼单已发起，人满后立即发货</div>
        <div
          class="icon_box  acea-row row-middle row-center"
          @click.stop="listenerActionClose"
        >
          <span class="iconfont icon-guanbi"></span>
        </div>
        <div class="acea-row row-middle">
          <div
            class="item"
            @click.stop="setShareInfoStatus"
            v-if="weixinStatus === true"
          >
            <div class="iconfont icon-weixin3"></div>
            <div class="">发送给朋友</div>
          </div>
          <div class="item" @click.stop="setPosterImageStatus">
            <div class="iconfont icon-haibao"></div>
            <div class="">生成海报</div>
          </div>
        </div>
      </div>
    </div>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
  </div>
</template>
<script>
import ShareInfo from "@components/ShareInfo";
import StorePoster from "@components/StorePoster";
import { wechatEvevt } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { imageBase64 } from "@api/public";
import { getUserInfo } from "@api/user";
import { getProductDetail, getProductCode } from "@api/store.js";
import { mapGetters } from "vuex";
import { setTimeout } from "timers";
// import { userShare } from "@api/user.js";
import { VUE_APP_IMG_URL } from "@utils/index";
export default {
  name: "pinkdetail",
  components: {
    StorePoster,
    ShareInfo
  },
  data() {
    return {
      detail: {},
      id: 0,
      posters: false,
      pinkinfo: {
        user: []
      },
      weixinStatus: false,
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      storeInfo: {}
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    } else {
      this.$dialog.toast({
        msg: "商品不存在或已下架!"
      });
      setTimeout(() => {
        this.$router.go(-1);
      }, 1500);
      return;
    }
    this.getdetail();
  },
  computed: mapGetters(["isLogin"]),
  methods: {
    setOpenShare: function() {
      var data = this.storeInfo;
      let pinkinfo = this.pinkinfo;
      // var href = location.href;
      var href = VUE_APP_IMG_URL + "/detail/" + this.id;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: "成团即开奖，1人中奖发商品，2人未中退全款奖红包",
              title: `【仅剩${pinkinfo.ptnum - pinkinfo.num}个名额】我${
                data.price
              }元拼了[${data.store_name}]`,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline"
              ],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.onMenuShareAppMessage(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                  res.wx.onMenuShareTimeline(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: "成团即开奖，1人中奖发商品，2人未中退全款奖红包",
            title: `【仅剩${pinkinfo.ptnum - pinkinfo.num}个名额】我${
              data.price
            }元拼了[${data.store_name}]`,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
        }
      }
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    listenerActionClose: function() {
      this.posters = false;
    },
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    // 获取商品详情
    getdetail() {
      let that = this;
      getProductDetail(this.id)
        .then(res => {
          console.log(res);
          this.pinkinfo = res.data.pt_info;
          this.detail = res.data;
          that.$set(that, "storeInfo", res.data.storeInfo);
          that.posterData.image = that.storeInfo.image_base;
          if (that.storeInfo.store_name.length > 30) {
            that.posterData.title =
              that.storeInfo.store_name.substring(0, 30) + "...";
          } else {
            that.posterData.title = that.storeInfo.store_name;
          }
          that.posterData.price = that.storeInfo.price;
          that.posterData.code = that.storeInfo.code_base;
          that.getImageBase64();
          that.setOpenShare();
        })
        .catch(res => {
          console.log(res);
          this.$dialog.toast({
            mes: res.msg
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
          return;
        });
    },
    shareCode: function(value) {
      var that = this;
      getProductCode(that.id).then(res => {
        if (res.data.code) that.posterData.code = res.data.code;
        value === false && that.listenerActionSheet();
      });
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}

.teamnum {
  background-color: #fff4c2;
  color: #ff4142;
  font-size: 3.73vw;
  width: 25.47vw;
  height: 7.47vw;
  border-radius: 0 4vw 4vw 0;
  align-items: center;
  margin-top: 6.67vw;

  img {
    width: 5.6vw;
    height: 5.6vw;
    margin: 0 2.13vw 0 1.33vw;
  }
}

.title {
  justify-content: center;
  align-items: center;
  height: 17.4vw;
  margin-bottom: 2.7vw;
  color: #ffffff;
  font-size: 4.8vw;

  span {
    max-width: 60vw;
  }
}

.pinkinfo {
  background-color: #ffffff;
  width: 94.67vw;
  border-radius: 2vw;
  padding: 2.93vw;
  margin: 0 2.67vw;

  .goodsinfo {
    .goods_img {
      width: 33.2vw;
      height: 33.2vw;
      border-radius: 1vw;
    }

    .info {
      width: 50vw;
      height: 33.2vw;
      flex-direction: column;
      padding: 2vw 0;

      > div {
        width: 100%;
      }

      .store_name {
        font-size: 4vw;
        color: #333333;
        font-weight: 600;
      }

      .progress {
        align-items: center;

        .progress_1 {
          width: 25.53vw;
          height: 3.2vw;
          margin-right: 1.73vw;
          border-radius: 1vw;
          background-color: rgba(255, 67, 64, 0.3);

          .sel {
            background-color: #ff4142;
            height: 100%;
          }
        }

        .num {
          color: #666666;
          font-size: 3.2vw;
        }
      }

      .butie {
        color: #ff4142;
        font-size: 3.2vw;

        .a {
          font-size: 4.8vw;
          font-weight: 600;
        }
      }
    }
  }

  .line {
    width: 100%;
    // background-color: #ebebeb;
    border: 1rpx dashed #ebebeb;
    position: relative;
    margin: 3.33vw 0;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: -4vw;
      width: 3vw;
      height: 3vw;
      border-radius: 2vw;
      background-color: #ff4142;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: -4vw;
      width: 3vw;
      height: 3vw;
      border-radius: 2vw;
      background-color: #ff4142;
    }
  }

  .pinkinfos {
    .qi {
      justify-content: center;
      align-items: center;

      .a {
        width: 7.07vw;
        height: 0.27vw;
        background-color: #ff4142;
        position: relative;

        &::after {
          position: absolute;
          content: "";
          width: 1.87vw;
          height: 1.87vw;
          border: 1rpx solid #ff4142;
          border-radius: 50%;
          top: 0;
          bottom: 0;
          right: -1.87vw;
          margin: auto 0;
        }
      }

      .b {
        color: #ff4142;
        font-style: italic;
        margin: 0 4vw 0 3vw;
      }

      .c {
        width: 7.07vw;
        height: 0.27vw;
        background-color: #ff4142;
        position: relative;

        &::before {
          position: absolute;
          content: "";
          width: 1.87vw;
          height: 1.87vw;
          border: 1rpx solid #ff4142;
          border-radius: 50%;
          top: 0;
          bottom: 0;
          left: -1.87vw;
          margin: auto 0;
        }
      }
    }

    .status {
      justify-content: center;
      align-items: center;
      margin: 2.5vw 0 1.5vw;

      img {
        width: 5.87vw;
        height: 5.87vw;
        margin-right: 2.53vw;
      }

      .a {
        color: #2dcc7d;
        font-style: 4vw;
      }
    }

    .num {
      color: #333333;
      font-style: 3.47vw;
      font-weight: 600;
      text-align: center;
      line-height: 8vw;

      .a {
        color: #ff4142;
      }
    }

    .userlist {
      width: 82.67vw;
      margin: 0 3.33vw;

      img {
        width: 8vw;
        height: 8vw;
        border-radius: 50%;
        margin-right: 2.67vw;
      }

      .more {
        margin-right: 0;
      }
    }
  }

  .invite_btn {
    background: linear-gradient(-45deg, #ff4340, #ff4a2d);
    color: #ffffff;
    width: 89.33vw;
    height: 11.73vw;
    line-height: 11.73vw;
    border-radius: 6vw;
    margin: 6.4vw 0 3.73vw;
  }

  .gohome {
    border: 1px solid #ff4142;
    display: inline-block;
    color: #ff4142;
    width: 89.33vw;
    height: 11.73vw;
    line-height: 11.73vw;
    border-radius: 6vw;
    text-align: center;
  }
}

.rule_title {
  justify-content: center;
  align-items: center;
  height: 14.93vw;

  img {
    width: 17.33vw;
    height: 2.93vw;
  }

  .a {
    margin: 0 1.87vw;
    font-style: 4.53vw;
    color: #fff4c2;
  }
}

.rule_img {
  width: 94.67vw;
  margin: 0 2.67vw;
}

.generate-posters {
  width: 80%;
  padding: 0.2rem;
  // height: 1.7rem;
  background-color: #fff;
  position: relative;
  border-radius: 8px;
  // position: fixed;
  // left: 50%;
  // bottom: 50%;
  z-index: 999;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  opacity: 0;
  .poster_title {
    text-align: center;
    font-size: 0.33rem;
    font-weight: bold;
    .a {
      color: red;
    }
  }
  .poster_tipe {
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .icon_box {
    background-color: #e0e0e0;
    border-radius: 50%;
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    right: -0.25rem;
    top: -0.25rem;
    line-height: 0.5rem;
    .iconfont {
      font-size: 0.25rem;
    }
  }
}

.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  opacity: 1;
}

.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}

.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}

.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
</style>
